<template>
  <v-app>
    <v-app-bar dense app scroll-threshold="0">
      <AppbarAccount></AppbarAccount>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import AppbarAccount from "./components/AppbarAccount";
export default {
  name: "App",
  components: {
    AppbarAccount,
  },
  data: () => ({
    //
  }),
};
</script>

<style>
.v-main {
  padding-bottom: 80px !important;
}
</style>
